import { render, staticRenderFns } from "./ProfileTransaction.vue?vue&type=template&id=574b5680"
import script from "./ProfileTransaction.vue?vue&type=script&lang=js"
export * from "./ProfileTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports